import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import sample from "../../../assets/kangaroo/img1.png";
import { imageBaseApi } from "../../../utilis/imageHelper";
import MediaService from "../../../services/KangarooServices/MediaServices";
import Select from "react-select";
import MediaGroupService from "../../../services/KangarooServices/MediaGroupService";
import { Triangle } from "react-loader-spinner";

const MediaModal = ({
  isOpen,
  toggle,

  selectedMedia,
  setSelectedMedia,
}) => {
  const [tempSelection, setTempSelection] = useState(selectedMedia);
  const [mediaData, setMediaData] = useState([]);
  const [mediaGroup, setMediaGroup] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: "",
    mediaGroupId: null,
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);
    return () => clearTimeout(timer);
  }, [filters]);
  const fetchMedia = async (page = 1, pageSize = 1000) => {
    setLoading(true);
    try {
      const res = await MediaService.getList({
        ...debouncedFilters,
        page,
        pageSize,
      });
      setMediaData(res || []);
    } catch (err) {
      console.error("Failed to load media");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMedia();
  }, [debouncedFilters]);

  const fetchGroup = async () => {
    try {
      setLoading(true);
      const response = await MediaGroupService.getAllList();
      setMediaGroup(response?.items);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchGroup();
  }, []);
  useEffect(() => {
    setTempSelection(selectedMedia);
  }, [selectedMedia, isOpen]);

  const handleSelect = (item) => {
    setTempSelection(item);
  };

  const handleAddMedia = () => {
    setSelectedMedia(tempSelection);
    toggle();
  };
  const mediaGroupOptions = mediaGroup.map((group) => ({
    label: group.name,
    value: group.id,
  }));
  const handleMediaGroupChange = (selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      mediaGroupId: selectedOption ? selectedOption.value : null,
    }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>Select Media</ModalHeader>
      <ModalBody>
        <div className="mb-3 col-6">
          <Select
            options={mediaGroupOptions}
            value={mediaGroupOptions.find(
              (option) => option.value === filters.mediaGroupId
            )}
            onChange={handleMediaGroupChange}
            placeholder="Select Media Group"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        </div>
        <Row>
          {/* Left Column: Media Grid */}

          <Col
            xs={12}
            md={8}
            className="border-end"
            style={{ maxHeight: "60vh", overflowY: "auto" }}
          >
            <Row>
              {loading ? (
                <div className="d-flex justify-content-center align-content-center align-items-center">
                  <Triangle />
                </div>
              ) : (
                <>
                  {mediaData?.items?.map((item) => {
                    const isSelected = tempSelection?.id === item.id;
                    const isImage = item.mimeType?.startsWith("image");
                    const isPDF = item.mimeType === "application/pdf";

                    return (
                      <Col xs={6} lg={3} className="mb-3" key={item.id}>
                        <div
                          className={`border rounded-3 p-1 text-center ${
                            isSelected ? "border-primary shadow-sm" : ""
                          }`}
                          style={{
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                          }}
                          onClick={() => handleSelect(item)}
                        >
                          {isImage && (
                            <img
                              src={`${imageBaseApi}${item?.url}` || sample}
                              alt={item.fileName}
                              style={{
                                width: "100%",
                                height: "100px",
                                objectFit: "contain",
                                borderRadius: "6px",
                              }}
                              loading="lazy"
                            />
                          )}
                          {isPDF && (
                            <div
                              className="d-flex flex-column justify-content-center align-items-center"
                              style={{ height: "100px" }}
                            >
                              <i className="bi bi-file-earmark-pdf-fill fs-2 text-danger"></i>
                            </div>
                          )}
                          {!isImage && !isPDF && (
                            <div
                              className="d-flex flex-column justify-content-center align-items-center"
                              style={{ height: "100px" }}
                            >
                              <i className="bi bi-file-earmark fs-2 text-secondary"></i>
                            </div>
                          )}
                        </div>
                      </Col>
                    );
                  })}
                </>
              )}
            </Row>
          </Col>

          {/* Right Column: Selected Media Details */}
          <Col xs={12} md={4} className="p-3">
            {tempSelection ? (
              <div className="text-center">
                {tempSelection.mimeType?.startsWith("image") ? (
                  <img
                    src={`${imageBaseApi}${tempSelection?.url}`}
                    alt={tempSelection.fileName}
                    style={{
                      width: "100%",
                      maxHeight: "250px",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                    loading="lazy"
                  />
                ) : tempSelection.mimeType === "application/pdf" ? (
                  <i className="bi bi-file-earmark-pdf-fill fs-1 text-danger"></i>
                ) : (
                  <i className="bi bi-file-earmark fs-1 text-secondary"></i>
                )}
                <h5
                  className="mt-3 text-truncate"
                  title={tempSelection.fileName}
                >
                  {tempSelection.fileName || "Unknown"}
                </h5>
                <p className="mb-1 text-muted">
                  Uploaded by: {tempSelection.uploadedBy || "Unknown"}
                </p>
                <p className="mb-1 text-muted">
                  Size: {(tempSelection.size / 1024).toFixed(2)} KB
                </p>
                <p className="mb-1 text-muted">
                  MIME Type: {tempSelection.mimeType}
                </p>
              </div>
            ) : (
              <p className="text-muted text-center mt-5">
                Select a media from the left to see details
              </p>
            )}
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        <button
          className="btn btn-success"
          onClick={handleAddMedia}
          disabled={!tempSelection}
        >
          Add Feature Media
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default MediaModal;
